var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C14.5877 21.25 16.9262 20.1884 18.6059 18.475C18.8958 18.1792 19.3707 18.1745 19.6665 18.4644C19.9623 18.7544 19.967 19.2292 19.677 19.525C17.7268 21.5144 15.007 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.2016 1.25 21.5389 4.94367 22.535 9.8508C22.6174 10.2567 22.3551 10.6526 21.9492 10.735C21.5432 10.8174 21.1474 10.5551 21.065 10.1492C20.208 5.92737 16.4742 2.75 12 2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5199 15.1895C15.9635 16.1127 16.9073 16.75 18 16.75C19.5188 16.75 20.75 15.5188 20.75 14C20.75 13.5858 20.4142 13.25 20 13.25C19.5858 13.25 19.25 13.5858 19.25 14C19.25 14.6904 18.6904 15.25 18 15.25C17.3096 15.25 16.75 14.6904 16.75 14V12C16.75 9.37665 14.6234 7.25 12 7.25C9.37665 7.25 7.25 9.37665 7.25 12C7.25 14.6234 9.37665 16.75 12 16.75C13.3957 16.75 14.6508 16.148 15.5199 15.1895ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.c20214f4a6a557ae766d32510549119d.svg";
export { ForwardRef as ReactComponent };